import React from 'react';
import cn from '@utils/cn';

type GradientOverlayProps = {
  isLeft: boolean;
  isVisible?: boolean;
  className?: string;
};

export default function GradientOverlay({ isLeft, isVisible = false, className }: GradientOverlayProps) {
  return (
    <div
      className={cn(
        'pointer-events-none absolute bottom-0 top-0 z-10 w-6 md:w-12',
        className,
        'from-[var(--background)] to-transparent opacity-0 transition-opacity',
        {
          'left-0 bg-gradient-to-r': isLeft,
          'right-0 bg-gradient-to-l': !isLeft,
          'opacity-100': isVisible,
        },
      )}
    />
  );
}
